import React, { Component } from 'react';
import './Footer.scss';
import {Link, withRouter, matchPath } from "react-router-dom";
import aebLogo from "../../assets/img/Aeb-logo.svg";
import fhhLogo from "../../assets/img/FHH.svg";
import abcFinanceLogo from "../../assets/img/abc_finance.svg";
import centralBankLogo from "../../assets/img/Central_Bank_of_Armenia_Logo.svg";
import fininfoLogo from "../../assets/img/fininfo.svg";
import zoomLogo from "../../assets/img/zoom-graphics.svg";
import fbLogo from "../../assets/img/fb.svg";
import linkedinLogo from "../../assets/img/linkedin.svg";
import telegramLogo from "../../assets/img/telegram.svg";
import instagramLogo from "../../assets/img/instagram.svg";
import youtubeLogo from "../../assets/img/youtube.svg";
import request from '../../Ajax';

class Footer extends Component {
  constructor(props) {
    super(props);
    const { location } = this.props
    const lng_url = location.pathname.substring(location.pathname.lastIndexOf('/')+1,location.pathname.lastIndexOf('/') +3);
    this.lng = lng_url === 'en' ? 2 : 1;

    this.inner_state = {
      labels: 'getLabels',
    };

    this.state = {
      labels: [],
    };
  }

  componentDidMount() {
    request(
        this.inner_state.labels,
        'post',
        { 'page_type' : 'footer', 'lang' : this.lng },
        (response) => {
          if (response.data.status === true) {
            this.setState({ labels: response.data.data });
          } else {
            //todo chgitem inch erb labelneri het kapvac xndir ka
          }
        }
    );
  }

  render() {
    return (
      <footer>
        <div className="footer_top">
          <div className="row align-center">
            <div className="column small-12 large-10">

              <div className="row">
                <div className="column small-12 large-8">
                  <div className="medium-flex-container row-wrap">
                    <div className="footer_logo">
                      <Link to="/">
                        <img src={aebLogo} alt="" />
                      </Link>
                    </div>

                    <div className="footer_desc">
                      <div className="footer_auth">
                        {this.state.labels.terms}
                        {/*Բանկը պատասխանատվություն չի կրում իր կայքում հղում կատարված ինտերնետային կայքերի*/}
                        {/*բովանդակության ստույգության և արժանահավատության, այնտեղ տեղադրված գովազդների և տեղեկատվության*/}
                        {/*օգտագործման հնարավոր հետևանքների համար:*/}
                      </div>
                      <div className="footer_directs">
                        {/* <a href="https://www.fsm.am/" target="_blank" rel="noopener noreferrer" title="">
                          <img src={fhhLogo} alt="" />
                        </a> */}
                        <a href="http://www.abcfinance.am" target="_blank" rel="noopener noreferrer" title="">
                          <img src={abcFinanceLogo} alt="" />
                        </a>
                        <a href="http://www.cba.am" target="_blank" rel="noopener noreferrer" title="">
                          <img src={centralBankLogo} alt="" />
                        </a>
                        <a href="https://www.fininfo.am" target="_blank" rel="noopener noreferrer" title="">
                          <img src={fininfoLogo} alt="" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="column small-12 large-4">

                  <div className="footer_contacts_side">
                    <div className="footer_contacts">
                      <div className="contact_item">
                        <i className="icon icon-phone">
                        </i>
                        <span>
                        <a href="tel:+37410510910"> +374 10 510-910 </a>
                        <a href="tel:+37480008686"> +374-8000-8686 </a>
                      </span>
                      </div>
                      <div className="contact_item">
                        <i className="icon icon-pin">
                        </i>
                        <span>
                        <a href="#!">
                          {this.state.labels.address}
                          {/*002, ք. Երևան, Ամիրյան փ. 23/1 */}
                        </a>
                      </span>
                      </div>
                      <div className="contact_item">
                        <i className="icon icon-message">
                        </i>
                        <span>
                        <a href="mailto:bank@aeb.am"> bank@aeb.am </a>
                      </span>
                      </div>
                    </div>

                    <div className="footer_social">
                      <a href="https://www.facebook.com/armeconombank/" className="social_item" target="_blank" rel="noopener noreferrer" title="Facebook">
                        <img src={fbLogo} alt="" />
                      </a>
                      <a href="https://www.linkedin.com/company/armeconombank-ojsc/" className="social_item" target="_blank" rel="noopener noreferrer" title="Twitter">
                        <img src={linkedinLogo} alt="" />
                      </a>
                      <a href="https://t.me/armeconombank_ojsc" className="social_item" target="_blank" rel="noopener noreferrer" title="Linkedin">
                        <img src={telegramLogo} alt="" />
                      </a>
                      <a href="https://www.instagram.com/armeconombank/" className="social_item" target="_blank" rel="noopener noreferrer" title="Linkedin">
                        <img src={instagramLogo} alt="" />
                      </a>
                      <a href="https://www.youtube.com/channel/UCGif2EMSWC9ZPyaAWdP_NNQ?view_as=subscriber" className="social_item" target="_blank" rel="noopener noreferrer" title="Linkedin">
                        <img src={youtubeLogo} alt="" />
                      </a>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="footer_bottom">
          <div className="row align-center">
            <div className="column small-12 large-10">
              <div className="medium-flex-container align-middle align-justify">
                <div className="footer_copyright">
                  Copyright © 2022-2023 ARMECONOMBANK. All rights reserved.
                  <br />
                  {this.state.labels.cba}
                </div>

                <div className="dev_logo">
                  <a href="https://www.zoom.am/" target="_blank" rel="noopener noreferrer" title="Zoom Graphics">
                    <img src={zoomLogo} alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}
export default withRouter(Footer)
